/**
 * Unsaved Changes Detection
 * Warns users when they try to navigate away from a page with unsaved form changes
 */

const unsavedChanges = {
    hasUnsavedChanges: false,
    originalFormData: {},
    trackedForms: [],

    /**
     * Get the translated warning message
     */
    getWarningMessage() {
        return window.appTranslations?.unsavedChangesWarning ||
            'Je hebt onopgeslagen wijzigingen. Weet je zeker dat je de pagina wilt verlaten?';
    },

    init() {
        this.trackForms();
        this.setupBeforeUnloadWarning();
        // Navigation warning removed - only using browser native beforeunload
    },

    /**
     * Track all forms on the page for changes
     */
    trackForms() {
        const forms = $('form:not(#filterform):not(#logout-form)');

        forms.each((index, form) => {
            const $form = $(form);

            // Skip forms that are explicitly marked as no-track
            if ($form.hasClass('no-track-changes') || $form.data('no-track-changes')) {
                return;
            }

            // Skip search/filter forms (GET method)
            const method = ($form.attr('method') || 'get').toLowerCase();
            if (method === 'get') {
                return;
            }

            this.trackedForms.push($form);

            // Store original form data
            this.originalFormData[index] = this.serializeForm($form);

            // Track changes on inputs
            $form.on('change keyup paste', 'input, textarea, select', () => {
                this.checkForChanges();
            });

            // Mark form as saved when submitted
            $form.on('submit', () => {
                this.markAsSaved();
            });
        });
    },

    /**
     * Serialize form data for comparison
     */
    serializeForm($form) {
        const formData = {};

        $form.find('input, textarea, select').each((index, element) => {
            const $element = $(element);
            const name = $element.attr('name');

            if (!name) return;

            if ($element.attr('type') === 'checkbox') {
                formData[name] = $element.is(':checked');
            } else if ($element.attr('type') === 'radio') {
                if ($element.is(':checked')) {
                    formData[name] = $element.val();
                }
            } else {
                formData[name] = $element.val();
            }
        });

        return formData;
    },

    /**
     * Check if any form has unsaved changes
     */
    checkForChanges() {
        this.hasUnsavedChanges = false;

        this.trackedForms.forEach(($form, index) => {
            const currentData = this.serializeForm($form);
            const originalData = this.originalFormData[index];

            // Compare current data with original
            if (JSON.stringify(currentData) !== JSON.stringify(originalData)) {
                this.hasUnsavedChanges = true;
            }
        });
    },

    /**
     * Setup warning when user tries to close/reload the page
     */
    setupBeforeUnloadWarning() {
        window.addEventListener('beforeunload', (e) => {
            if (this.hasUnsavedChanges) {
                const message = this.getWarningMessage();
                e.preventDefault();
                e.returnValue = message; // Standard for most browsers
                return message; // For older browsers
            }
        });
    },

    /*
     * Navigation warning is disabled - only browser native beforeunload is used
     * This prevents intrusive confirm dialogs on every link click
     * The browser will automatically show a warning when closing/reloading the page
     */

    /**
     * Mark forms as saved (call this after successful form submission)
     */
    markAsSaved() {
        this.hasUnsavedChanges = false;

        // Update original form data to current state
        this.trackedForms.forEach(($form, index) => {
            this.originalFormData[index] = this.serializeForm($form);
        });
    },

    /**
     * Manually mark that there are unsaved changes
     */
    setUnsaved() {
        this.hasUnsavedChanges = true;
    },

    /**
     * Reset tracking (useful when form is dynamically reloaded)
     */
    reset() {
        this.hasUnsavedChanges = false;
        this.originalFormData = {};
        this.trackedForms = [];

        // Remove all event listeners
        $('form').off('change keyup paste');
        $('form').off('submit');
    }
};

module.exports = {
    init: () => unsavedChanges.init(),
    markAsSaved: () => unsavedChanges.markAsSaved(),
    setUnsaved: () => unsavedChanges.setUnsaved(),
    reset: () => unsavedChanges.reset(),
    hasChanges: () => unsavedChanges.hasUnsavedChanges
};

